export default "__VITE_ASSET__Cffyt2ZV__"